module.exports = __webpack_public_path__ + "static/media/mavisgate.593e38eb.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/projetos/mavisgate.png
// module id = 84
// module chunks = 0